import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import config from '@plone/volto/registry';
import { formatUrl } from '@plone/volto/helpers/Api/Api';

import { getActiveLanguage } from './homepageUrl';
import { medicalServicesSegment, medicalFolderSegment } from './localizedSectionPath';

export const getContentApiRoot = (language) => {
  const lang = language || config.settings.defaultLanguage || 'ca';
  const apiPath = config.settings.apiPath || '';
  const separator = apiPath.endsWith('/') ? '' : '/';
  return `${apiPath}${separator}${lang}`;
};

export const getHomepageContentUrl = (
  language,
  { fullobjects = true } = {},
) => {
  const homepageId =
    config.settings.homepageContentId ||
    config.settings.homepagePath ||
    'pagina-inicial';
  const lang = language || config.settings.defaultLanguage || 'ca';
  const query = fullobjects ? '?fullobjects=1' : '';
  return formatUrl(`/${lang}/${homepageId}${query}`);
};

export const useContentApiRoot = () => {
  const { pathname } = useLocation();
  const locale = useSelector((state) => state.intl.locale);
  const language = getActiveLanguage(pathname, locale);
  return getContentApiRoot(language);
};

export const getMetgesUrl = (language) => {
  const lang = language || config.settings.defaultLanguage || 'ca';
  const section = medicalServicesSegment(lang);
  return formatUrl(`/${lang}/${section}/metges/@items_cached`);
};

export const getMetgesActivitatUrl = (language) => {
  const lang = language || config.settings.defaultLanguage || 'ca';
  const section = medicalServicesSegment(lang);
  return formatUrl(`/${lang}/${section}/metgesactivitat/@items_cached`);
};

export const getEspecialitatsUrl = (language) => {
  const lang = language || config.settings.defaultLanguage || 'ca';
  const section = medicalServicesSegment(lang);
  return formatUrl(
    `/${lang}/${section}/${medicalFolderSegment('especialitats', lang)}/@search?b_size=100`,
  );
};

export const getUnitatsEspecialitzadesUrl = (language) => {
  const lang = language || config.settings.defaultLanguage || 'ca';
  const section = medicalServicesSegment(lang);
  return formatUrl(
    `/${lang}/${section}/${medicalFolderSegment('unitats-especialitzades', lang)}?fullobjects=1`,
  );
};

export const getContentSlug = (item) =>
  item?.id || item?.['@id']?.split('/').filter(Boolean).pop() || '';

export const buildEspecialitatsSelectOptions = (items, language = 'ca') =>
  (items || [])
    .filter((item) => item['@type'] === 'csjespecialitats')
    .sort((a, b) => a.title.localeCompare(b.title, language))
    .map((item) => {
      const slug = getContentSlug(item);
      return { key: slug, value: slug, text: item.title };
    })
    .filter((option) => option.value);
